import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import type { Experiment } from '@ms/yammer-data/dist/state/types';
import { MetaOsHubHostName } from '@ms/yammer-web-support/dist/metaOsHub';
import config from 'bootstrap/config';

import { persistConfig } from '../../persistedState';

const ENGAGE_TEAMS_CLIENT_ID = 'aea37b53-7b1d-462c-818f-1f8726b993c9';
const ENGAGE_OUTLOOK_CLIENT_ID = 'bed31bef-a727-4e24-941d-6b52d8a6f83a';

const YAMMER_RESOURCE_SCOPE = 'https://web.yammer.com/teams/access_as_user';
const AUGLOOP_RESOURCE_SCOPE = 'https://augloop.office.com/v2/AugLoop.Copilot';
const LOKI_RESOURCE_SCOPE = 'https://loki.delve.office.com/User.Read';

interface NaaAppIdHostConfig {
  readonly experiment: Experiment;
  readonly clientId: string;
}

type HostNameToConfigMapping = Partial<Record<MetaOsHubHostName, NaaAppIdHostConfig>>;
const hostNameToConfig: HostNameToConfigMapping = {
  [MetaOsHubHostName.outlook]: {
    experiment: 'NaaAppIdEngageOutlookMetaOs',
    clientId: ENGAGE_OUTLOOK_CLIENT_ID,
  },
  [MetaOsHubHostName.outlookWin32]: {
    experiment: 'NaaAppIdEngageOutlookMetaOs',
    clientId: ENGAGE_OUTLOOK_CLIENT_ID,
  },
};

const TEAMS_DEFAULT_CONFIG: NaaAppIdHostConfig = {
  experiment: 'NaaAppIdEngageTeamsMetaOs',
  clientId: ENGAGE_TEAMS_CLIENT_ID,
};

type DeepMutable<T> = { -readonly [P in keyof T]: DeepMutable<T[P]> };

type ApplyNaaClientIdOverride = (hostName: MetaOsHubHostName) => Promise<void>;
export const applyNaaClientIdOverride: ApplyNaaClientIdOverride = async (hostName) => {
  const hostConfig = hostNameToConfig[hostName] ?? TEAMS_DEFAULT_CONFIG;

  const isEnabled = (await getPersistedExperimentTreatment(persistConfig.key, hostConfig.experiment)) === true;
  if (!isEnabled) {
    return;
  }

  const mutableConfig = config as DeepMutable<typeof config>;
  mutableConfig.msal.clientId = hostConfig.clientId;
  mutableConfig.msal.resources.yammer = YAMMER_RESOURCE_SCOPE;
  mutableConfig.msal.resources.augLoop = AUGLOOP_RESOURCE_SCOPE;
  mutableConfig.msal.resources.loki = LOKI_RESOURCE_SCOPE;
};
